import React, { useState } from 'react';
import { FiCheck, FiDownload, FiFileText, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {
  downloadHtmlResume,
  downloadPdfResume
} from '../utils/exportResume';

function ExportModal({ bioData, onClose }) {
  const [exportingType, setExportingType] = useState('');
  const [completedType, setCompletedType] = useState('');
  const [error, setError] = useState('');

  const handleExport = async (type) => {
    setExportingType(type);
    setCompletedType('');
    setError('');

    try {
      if (type === 'pdf') {
        await downloadPdfResume(bioData);
      } else {
        downloadHtmlResume(bioData);
      }
      setCompletedType(type);
    } catch (exportError) {
      console.error(`${type.toUpperCase()} export failed:`, exportError);
      setError(`The ${type.toUpperCase()} file could not be generated. Please try again.`);
    } finally {
      setExportingType('');
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto bg-black/85 p-4 backdrop-blur-sm animate-fade-in">
      <div className="relative my-auto w-full max-w-lg rounded-2xl border border-zinc-800 bg-zinc-900 p-6 shadow-2xl animate-scale-in sm:p-8">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-lg p-2 text-zinc-500 transition-colors hover:bg-zinc-800 hover:text-white"
          aria-label="Close download options"
        >
          <SafeIcon icon={FiX} />
        </button>

        <div className="mb-7 pr-8">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-zinc-700 bg-zinc-800">
            <SafeIcon icon={FiDownload} className="text-2xl text-white" />
          </div>
          <h2 className="mb-2 text-2xl font-bold text-white">Download Resume</h2>
          <p className="text-sm leading-relaxed text-zinc-400">
            Export a portable website or a polished, print-ready A4 PDF.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2">
          <button
            onClick={() => handleExport('html')}
            disabled={Boolean(exportingType)}
            className="group rounded-xl border border-zinc-700 bg-zinc-800 p-4 text-left transition-all hover:border-zinc-500 hover:bg-zinc-700 disabled:cursor-wait disabled:opacity-50"
          >
            <SafeIcon icon={FiFileText} className="mb-4 text-2xl text-zinc-300" />
            <span className="block font-bold text-white">
              {exportingType === 'html' ? 'Generating...' : 'Download HTML'}
            </span>
            <span className="mt-1 block text-xs leading-relaxed text-zinc-400">
              Interactive links and responsive online layout
            </span>
          </button>

          <button
            onClick={() => handleExport('pdf')}
            disabled={Boolean(exportingType)}
            className="group rounded-xl border border-white bg-white p-4 text-left transition-all hover:bg-zinc-200 disabled:cursor-wait disabled:opacity-50"
          >
            <SafeIcon icon={FiDownload} className="mb-4 text-2xl text-black" />
            <span className="block font-bold text-black">
              {exportingType === 'pdf' ? 'Formatting A4...' : 'Download A4 PDF'}
            </span>
            <span className="mt-1 block text-xs leading-relaxed text-zinc-600">
              High-resolution and optimized for printing
            </span>
          </button>
        </div>

        {completedType && (
          <div className="mt-4 flex items-center justify-center gap-2 rounded-lg border border-emerald-500/20 bg-emerald-500/10 p-3 text-sm text-emerald-400 animate-fade-in">
            <SafeIcon icon={FiCheck} />
            {completedType.toUpperCase()} export completed successfully.
          </div>
        )}

        {error && (
          <div className="mt-4 rounded-lg border border-red-500/20 bg-red-500/10 p-3 text-center text-sm text-red-400">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}

export default ExportModal;